import React, { Component } from 'react'
import PropTypes from 'prop-types'
import DtoDetailStation from '../../dto/DtoDetailStation'
import { getDate } from '../../../utils/DateUtil'
import { connect } from 'react-redux'
import { find } from 'lodash'
import AppStore from '../../../store/AppStore'
import DetailStationAction from '../../actions/DetailStationAction'
import DtoCity from '../../../referential/dto/DtoCity'
import i18n from 'simple-react-i18n'

class DescriptionStationPanel extends Component {
	getAltitude = () => {
		if (this.props.station.altitude) {
			const title = i18n.altitude
			const value = this.props.station.altitude + ' m'
			if (this.props.detail) {
				return this.getDetailLine(title, value)
			}
			return this.getSummaryLine(title, value)
		}
		return null
	}

	getCity = () => {
		if (this.props.station.site.city) {
			const city = find(this.props.cities, (o) => {
				return o.id == this.props.station.site.city
			})
			if (city) {
				const title = i18n.town
				const value = city.name + ' [' + city.code + ']'
				if (this.props.detail) {
					return this.getDetailLine(title, value)
				}
				return this.getSummaryLine(title, value)
			}
			return null
		}
		return null
	}

	getWaterMass = () => {
		if (this.props.station.waterMass) {
			const title = i18n.watershed
			const value = this.props.station.waterMass.code + ' - ' + this.props.station.waterMass.name
			if (this.props.detail) {
				return this.getDetailLine(title, value)
			}
			return this.getSummaryLine(title, value)
		}
		return null
	}
	getHydrologicArea = () => {
		if (this.props.station.hydrologicArea) {
			const title = i18n.hydrographicEntity
			const value = this.props.station.hydrologicArea.code + ' - ' + this.props.station.hydrologicArea.name
			if (this.props.detail) {
				return this.getDetailLine(title, value)
			}
			return this.getSummaryLine(title, value)
		}
		return null
	}
	getAddressComplement = () => {
		if (this.props.station.site.address) {
			let result = this.props.station.site.address.localizationName
			if (!result) {
				result = this.props.station.site.address.address
			}
			if (result) {
				const title = i18n.localization
				if (this.props.detail) {
					return this.getDetailLine(title, result)
				}
				return this.getSummaryLine(title, result)
			}
			return null
		}
		return null
	}

	getStationDate = (getBeginDate = false) => {
		const dateBegin = getDate(this.props.station.beginningDate)
		const dateEnd = getDate(this.props.station.endingDate)
		if (this.props.detail) {
			const end = dateEnd ? dateEnd : i18n.inProgress
			return this.getDetailLine(i18n.openingDate + ' - ' + i18n.closingDate, dateBegin + ' - ' + end)
		} else if (getBeginDate) {
			return this.getSummaryLine(i18n.openingDate, dateBegin)
		}
		return this.getSummaryLine(i18n.closingDate, dateEnd)
	}

	getCoordinate = () => {
		if (this.props.station.site.localization) {
			const title = i18n.coordinate
			const coordinate = 'X: ' + this.props.station.site.localization.xCoordinate + ' - ' + 'Y: ' + this.props.station.site.localization.yCoordinate
			if (this.props.detail) {
				return this.getDetailLine(title, coordinate)
			}
			return this.getSummaryLine(title, coordinate)
		}
		return null
	}
	getDetailLine = (title, value) => {
		return (
			<div className='row no-margin'><b>{ title }</b><br />
				<span className='black-text'> { value }</span>
			</div>
		)
	}

	getSummaryLine = (title, value) => {
		return (
			<div className='row blue-title light no-margin'>{ title } :
				<span className='light white-text'> { value }</span>
			</div>
		)
	}
	synchroniseButton = () => {
		if (this.props.station.code && this.props.station.code.indexOf('X') !== -1) {
			// return (<a className='btn' onClick={ this.synchronise }><span>Synchroniser</span></a>)
			return null
		}
		return null
	}
	synchronise = () => {
		AppStore.dispatch(DetailStationAction.synchroniseAdesSites(this.props.station.id, this.props.station.code))
	}

	getContent = () => {
		if (this.props.detail) {
			return (
				<div>
					<div className='row no-margin white-background'>
						<div className='col s12 m12 l12 no-padding card-title hide-on-med-and-down no-margin'>
							<div className='row primary-light white-text no-margin'>
								<div className='col l12'><h5>{ i18n.description }</h5></div>
							</div>
						</div>
					</div>
					<div className='row no-margin white-background'>
						<div className='col s12'>
							{ this.getCity() }
							{ this.getAddressComplement() }
							{ this.getStationDate() }
							{ this.getHydrologicArea() }
							{ this.getWaterMass() }
							{ this.getAltitude() }
							{ this.getCoordinate() }
						</div>
					</div>
				</div>
			)
		}
		return (
			<div className='row blue-card-dark' id='descriptionPanel'>
				<div className='col s8 '>
					{ this.getCity() }
					{ this.getStationDate(true) }
					{ this.getStationDate(false) }
				</div>
				<div className='col s4 left'>
					{ this.synchroniseButton() }
				</div>
			</div>
		)
	}

	render() {
		return (
			<div>{ this.getContent() }</div>
		)
	}
}

DescriptionStationPanel.propTypes = {
	station: PropTypes.instanceOf(DtoDetailStation),
	cities: PropTypes.arrayOf(PropTypes.instanceOf(DtoCity)),
	detail: PropTypes.bool
}

DescriptionStationPanel.defaultProps = {
	detail: false
}

const mapStateToProps = store => {
	return {
		station: store.DetailStationReducer.station,
		cities: store.ReferentialReducer.cities
	}
}

export default connect(mapStateToProps)(DescriptionStationPanel)



// WEBPACK FOOTER //
// ./src/station/components/description/DescriptionStationPanel.js